export default __webpack_public_path__ + "static/media/rsk_wallet.4a79606f.png";